import type { JSX } from "react";

import {
  Slider,
  SliderControl,
  SliderThumb,
  SliderTrack,
} from "@frontend/components/atoms/Slider";

import { useColorPickerContext } from "./ColorPicker.context";
import type { ColorPickerValueSliderProps } from "./ColorPicker.types";
import { hsvToHex } from "./colorMath";

export function ColorPickerValueSlider({
  className,
}: ColorPickerValueSliderProps): JSX.Element {
  const { hsv, hex, disabled, setHsv } = useColorPickerContext();

  return (
    <Slider
      data-slot="color-picker-value-slider"
      className={className}
      min={0}
      max={100}
      value={hsv.v}
      disabled={disabled}
      onValueChange={(value) => setHsv({ v: value })}
    >
      <SliderControl>
        <SliderTrack
          style={{
            backgroundImage: `linear-gradient(to right, #000, ${hsvToHex({ ...hsv, v: 100 })})`,
          }}
        >
          <SliderThumb style={{ backgroundColor: hex }} />
        </SliderTrack>
      </SliderControl>
    </Slider>
  );
}
